import { render, staticRenderFns } from "./SupplyChain.vue?vue&type=template&id=4ffcd936&"
import script from "./SupplyChain.vue?vue&type=script&lang=js&"
export * from "./SupplyChain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ffcd936')) {
      api.createRecord('4ffcd936', component.options)
    } else {
      api.reload('4ffcd936', component.options)
    }
    module.hot.accept("./SupplyChain.vue?vue&type=template&id=4ffcd936&", function () {
      api.rerender('4ffcd936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/Editor/Study/SupplyChain.vue"
export default component.exports